import { useEffect } from "react";
import PricingSection from "../../pricing/view/PricingSection";
import { CreditAlertsView } from "./CreditAlerts/view/creditAlertsView";
import { CreditHistoryView } from "./CreditHistory/view/CreditHistoryView";
import { ApprovalFlowView } from "./JobApproval/view/ApprovalFlowList";
import { PoolNameView } from "./JobApproval/view/PoolNameViewList";
import { useApprovalFlowViewModel } from "./JobApproval/viewmodel/approvalFlowViewModel";
import { useApprovalViewModel } from "./JobApproval/viewmodel/approvalViewModel";
import { useLocation } from "react-router-dom";

export const CompanySettingTabsView = () => {
  const approvalFlowVM = useApprovalFlowViewModel();
  const { state, dispatch } = approvalFlowVM;
  const approvalVM = useApprovalViewModel();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.activeTab) {
      dispatch({
        type: "SET_ACTIVE_TAB",
        payload: location.state.activeTab,
      });
    }
  }, [location.state]);
  return (
    <div className="px-4 sm:px-6 lg:px-8 py-4 sm:py-6 max-w-7xl mx-auto">
      <div className="mb-6">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex overflow-x-auto gap-6 sm:gap-8 scrollbar-hide">
            <button
              onClick={() =>
                dispatch({ type: "SET_ACTIVE_TAB", payload: "Approval Flow" })
              }
              className={`whitespace-nowrap py-3 sm:py-4 px-2 sm:px-1 border-b-2 font-medium text-sm ${
                state.activeTab === "Approval Flow"
                  ? "border-indigo-500 text-indigo-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              <div className="flex items-start sm:items-center gap-2">
                <div className="text-left">
                  <div className="flex items-center space-x-2">
                    <span>Approval Flow</span>
                  </div>
                  <div className="text-xs text-gray-500 font-normal">
                    Create and manage Approval Flows
                  </div>
                </div>
              </div>
            </button>
            <button
              onClick={() =>
                dispatch({
                  type: "SET_ACTIVE_TAB",
                  payload: "Pool Names",
                })
              }
              className={`whitespace-nowrap py-3 sm:py-4 px-2 sm:px-1 border-b-2 font-medium text-sm ${
                state.activeTab === "Pool Names"
                  ? "border-indigo-500 text-indigo-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              <div className="flex items-start sm:items-center gap-2">
                <div className="text-left">
                  <div className="flex items-center space-x-2">
                    <span>Pools</span>
                  </div>
                  <div className="text-xs text-gray-500 font-normal">
                    Manage pool names
                  </div>
                </div>
              </div>
            </button>
            <button
              onClick={() =>
                dispatch({ type: "SET_ACTIVE_TAB", payload: "Subscription" })
              }
              className={`whitespace-nowrap py-3 sm:py-4 px-2 sm:px-1 border-b-2 font-medium text-sm ${
                state.activeTab === "Subscription"
                  ? "border-indigo-500 text-indigo-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              <div className="flex items-start sm:items-center gap-2">
                <div className="text-left">
                  <div className="flex items-center space-x-2">
                    <span>Subscription</span>
                  </div>
                  <div className="text-xs text-gray-500 font-normal">
                    Manage subscription settings
                  </div>
                </div>
              </div>
            </button>{" "}
            <button
              onClick={() =>
                dispatch({ type: "SET_ACTIVE_TAB", payload: "Credit Usage" })
              }
              className={`whitespace-nowrap py-3 sm:py-4 px-2 sm:px-1 border-b-2 font-medium text-sm ${
                state.activeTab === "Credit Usage"
                  ? "border-indigo-500 text-indigo-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              <div className="flex items-start sm:items-center gap-2">
                <div className="text-left">
                  <div className="flex items-start sm:items-center gap-2">
                    <span>Credit Usage</span>
                  </div>
                  <div className="text-xs text-gray-500 font-normal">
                    View and manage credit history
                  </div>
                </div>
              </div>
            </button>
            <button
              onClick={() =>
                dispatch({ type: "SET_ACTIVE_TAB", payload: "Credit Alerts" })
              }
              className={`whitespace-nowrap py-3 sm:py-4 px-2 sm:px-1 border-b-2 font-medium text-sm ${
                state.activeTab === "Credit Alerts"
                  ? "border-indigo-500 text-indigo-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              <div className="flex items-center space-x-2">
                <div className="text-left">
                  <div className="flex items-center space-x-2">
                    <span>Credit Alerts</span>
                  </div>
                  <div className="text-xs text-gray-500 font-normal">
                    View and manage credit alerts
                  </div>
                </div>
              </div>
            </button>
          </nav>
        </div>
      </div>
      {state.activeTab === "Approval Flow" && (
        <ApprovalFlowView
          approvalVM={approvalVM}
          approvalFlowVM={approvalFlowVM}
        />
      )}
      {state.activeTab === "Pool Names" && (
        <PoolNameView approvalVM={approvalVM} />
      )}
      {state.activeTab === "Subscription" && (
        <PricingSection isFromSubscription={true}></PricingSection>
      )}
      {state.activeTab === "Credit Usage" && <CreditHistoryView />}
      {state.activeTab === "Credit Alerts" && (
        <CreditAlertsView></CreditAlertsView>
      )}
    </div>
  );
};
